import { render, staticRenderFns } from "./rechargeRecovery.vue?vue&type=template&id=5f2248b4&scoped=true&"
import script from "./rechargeRecovery.vue?vue&type=script&lang=js&"
export * from "./rechargeRecovery.vue?vue&type=script&lang=js&"
import style0 from "./rechargeRecovery.vue?vue&type=style&index=0&rel=stylesheet%2Fscss&lang=scss&"
import style1 from "./rechargeRecovery.vue?vue&type=style&index=1&id=5f2248b4&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f2248b4",
  null
  
)

export default component.exports